<mat-menu #contextMenu="matMenu" [class]="panelClass">
	<div (keydown)="handleMenuKeyDown($event)" (outsideClick)="closeMenu()" outsideClick>
		<ng-content></ng-content>
	</div>
</mat-menu>

<div #menuTrigger class="menu-trigger"
	[style.left.px]="contextMenuPosition.x"
	[style.top.px]="contextMenuPosition.y"
	[matMenuTriggerFor]="contextMenu"
	[matMenuTriggerRestoreFocus]="false">
</div>
